import FormEmailHookCtl from 'root/main/components/forms/formEmailHookCtl';
import lightboxFormInit from 'root/main/components/forms/lightbox/lightboxFormInit';
import {
    waitForVWOCampaign,
    getVWOCampaignName,
    getCookieByPartialName,
} from './lightbox/waitForVWOCookie';

const forms = [
    {
        selector: 'button[data-select=form-submit]',
        path: { filename: 'formControllerInit' },
    },
    {
        selector: '[data-form-custom=agnostic-business-type]',
        path: { filename: 'agnosticFormControllerInit' },
    },
    {
        selector: '[data-form-name*=email_only]',
        path: { filename: 'emailOnlyFormCtl' },
    },
    {
        selector: '[data-form-name=resto_resources_tool]',
        path: { filename: 'menuTemplate' },
    },
    {
        selector: '[data-form=ls-form]',
        path: { filename: 'formUIInit' },
    },
    {
        selector: '[data-form=ls-form-steps]',
        path: { filename: 'formUISliderInit' },
    },
    {
        selector: '[data-form-name=other_partner_application]',
        path: { filename: 'formUIConditionalInit' },
    },
    {
        selector: '[data-auto-fill-form-values]',
        path: { filename: 'autoFillFormValues' },
    },
];

async function lightboxHandler(event: Event) {
    const target =
        event.target instanceof HTMLElement
            ? event.target.closest<HTMLAnchorElement>('A')
            : null;
    if (target && target.href) {
        const url = new URL(target.href);

        if (url.hash.startsWith('#lightbox|')) {
            if (url.hash.includes('free-trial')) {
                event.preventDefault();
                lightboxFormInit(event, decodeURI(target.href));
                return;
            }

            const isVWOCampaignRunning = await waitForVWOCampaign();

            if (isVWOCampaignRunning) {
                // the reason we didn't use cm.getCookie here is because sometimes the cookie name will have a suffix (e.g. _vis_opt_exp_111_combi_choose instead of _vis_opt_exp_111_combi)
                // the getCookieByPartialName function will return the value of the cookie if it finds the cookie with the base name (with or without suffix)
                const campaignVariation = getCookieByPartialName(getVWOCampaignName());
                if (campaignVariation === 1) {
                    event.preventDefault();
                    lightboxFormInit(event, decodeURI(target.href));
                    return;
                }
                if (campaignVariation === 2) {
                    target.href = target.href.replace('wizard-lightbox', 'email-hook');
                    event.preventDefault();
                    FormEmailHookCtl().init(event, decodeURI(target.href));
                    return;
                }
            } else {
                event.preventDefault();
                lightboxFormInit(event, decodeURI(target.href));
                return;
            }
        }
    }
}

export { forms, lightboxHandler };
